<div id="lessonTermsContainer" class="lesson-terms-container" [ngClass]="rootClassName">
  <ng-template [ngTemplateOutlet]="_header"></ng-template>
  <div class="frame8pxspacer"></div>
  <div class="lesson-terms-contentblock">
    @if (subscribed) {
      <div class="lesson-terms-completion-row">
        <pop-ui-lesson-tile-completion [stats]="stats"></pop-ui-lesson-tile-completion>
      </div>
    }
  </div>
  <div class="frame8pxspacer"></div>
  @defer (when isLoaded) {
    <ng-template [ngTemplateOutlet]="_content"></ng-template>
  } @placeholder {
    <nx-superprep-dot-flashing></nx-superprep-dot-flashing>
  }
</div>

<ng-template #_header>
  <div class="lesson-terms-title-container">
    <div class="lesson-terms-title-row">
      <div class="lesson-terms-title-col image">
        <img loading="lazy" [src]="imageURL|async" alt="{{image}}" class="lesson-terms-title-image"/>
      </div>
      <div class="lesson-terms-title-col description">
        <span class="lesson-terms-title-text title headingboldxlarge">{{title}}</span>
        @if(isWeb) {
          <div class="frame16pxspacer"></div>
          <span class="lesson-terms-title-text description">{{description}}</span>
          <div class="frame16pxspacer"></div>
          @if (subject) {
            <ng-template [ngTemplateOutlet]="_subject_badge"></ng-template>
          }
          <div class="frame16pxspacer"></div>
          <ng-template [ngTemplateOutlet]="_actions"></ng-template>
        }
      </div>
    </div>
    @if (!isWeb) {
      <div class="frame16pxspacer"></div>
      <span class="lesson-terms-title-text description">{{description}}</span>
      @if (subject) {
        <div class="frame16pxspacer"></div>
        <ng-template [ngTemplateOutlet]="_subject_badge"></ng-template>
      }
      <div class="frame16pxspacer"></div>
      <ng-template [ngTemplateOutlet]="_actions"></ng-template>
    }
  </div>
</ng-template>

<ng-template #_subject_badge>
  <div class="subject-badge-container">
    <div class="subject-badge" [ngStyle]="{'background-color':subjectBackgroundColor, 'color':subjectTextColor}">
      <span class="labelsmallregular">{{subject}}</span>
    </div>
  </div>
</ng-template>

<ng-template #_actions>
  <div class="lesson-terms-action-container" [ngClass]="{'web':isWeb}">
    @if (isValid()) {
      @for (action of actions; track $index) {
      <div (click)="onAction(action.name)" class="lesson-terms-action" [ngClass]="actionClass(action.name)" tooltip="{{actionTip(action.name)}}">
        @if (action.iconURL) {
          <img loading="lazy" [src]="action.iconURL" [alt]="action.iconALT" class="lesson-terms-icon" [ngClass]="iconClass(action.name)"/>
        }
        <span class="labelboldsmall">{{actionText(action.name)}}</span>
      </div>
      }
    } @else {
      <span class="labelboldsmall">coming soon !</span>
    }
  </div>
</ng-template>

<ng-template #_content>
  <div class="lesson-terms-content-container">
    <div class="lesson-terms-content">
      <div class="lesson-terms-contentblockterms noscrollbar">
        <div class="lesson-terms-row">
          <div class="lesson-terms-row">
            <div class="lesson-terms-about-col">
              <span class="lesson-terms-title-text start headingboldsmall">
                <span>Target Concepts:</span>
              </span>
              <span class="lesson-terms-title-text end headingregularsmall">
                <span>{{countTitle}}</span>
              </span>
            </div>
            <hr class="divider" />
          </div>
          <div class="lesson-terms-table">
            @for (term of terms|async; track $index; let isLast=$last) {
              <pop-ui-lesson-tile-term [term]="term"></pop-ui-lesson-tile-term>
              @if (isLast && !isWeb) { <div class="frame100pxspacer"></div> }
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
